export default __webpack_public_path__ + "static/media/Inter-Black.143c2842.ttf";